import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatDate,
  formatDateToIST,
  formatTo12Hour,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import ProductModal from "../ProductModal";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
// import AssignOffCanvance from "../AssignDeliveryBoy";
// import ProductModal from "../ProductModal";
// import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";

import search1 from "../../../assets/icons/search.png";
import plus from "../../../../Components/assets/icons/a1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CancelOrderModel from "../CancelOrderModel";
import AddOffCanvance from "./Add";
function PendingOrdersTable({
  user,
  OrderByOptions,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Pending || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${searchCustomer || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);
  console.log(data, "hhhhhhhhhhh");

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  console.log("option", option);

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
      await GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = (invoiceUrl) => {
    // Make a GET request to the backend to trigger the download
    const link = document.createElement("a");
    link.href = invoiceUrl; // The URL of the invoice file on the server
    link.target = "_blank";
    link.download = true; // This ensures the browser triggers a download
    link.click();
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Pending || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  const [showCancelOrder, setShowCancelOrder] = useState({
    show: 0,
    data: {},
  });

  const [show, setShowAdd] = useState(false);
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);
  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            {isAllow.includes(IDS.Order.Add) ? (
              <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="add me-3">
                  <Link type="button" className="btn btn-add pe-3">
                    <div onClick={() => handleShow()}>
                      <img src={plus} className="plus me-2 ms-0" alt="" />
                      Add Order
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              <></>
            )}

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            {/* <div className="col-lg-3 mb-2">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                placeholder="Enter Product Name"
                type="text"
                className="form-control"
                id=""
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div> */}
            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
              <div className="Search me-2">
                <Form.Label>Search</Form.Label>
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
              <div className="Search-1">
                <Form.Label>Reset</Form.Label>
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setProductCategory("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>

            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <strong>Total Amount:</strong> ₹
          {Number(data?.data?.total_selling_value || 0).toFixed(2)}
        </div>
        <div>
          <strong>Average Amount:</strong> ₹
          {Number(data?.data?.average_selling_value || 0).toFixed(2)}
        </div>
        {/* <div>
          <strong>Total Kg:</strong>{" "}
          {Number(data?.data?.total_weight || 0).toFixed(2)} kg
        </div> */}
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Order details</th>

              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-id">
                    {formatDateToIST(item?.createdAt)}
                    {/* {item?.createdAt} */}
                  </div>
                  {/* <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div> */}
                  {/* <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div> */}
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    {item?.invoice_no}
                  </div>
                  <div className="order-info">
                    <span>
                      {" "}
                      <b> Buyer Name</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span className="text-highlight">{item?.User?.name}</span>
                  </div>
                  <div className="order-info">
                    <span className="order-info">{item?.User?.contact_no}</span>
                  </div>

                  <div className="order-info">
                    <span>
                      {" "}
                      <b> Payment Method</b>
                    </span>{" "}
                    : <span>{item?.Payment_Method?.name}</span>
                  </div>

                     <div className="order-info">
                    <span>
                      {" "}
                      <b> Transaction ID</b>
                    </span>{" "}
                    : <span>{item?.Order_Payment_Detail?.payment_id}</span>
                  </div>
                </td>

                <td className="order-details">
                  {item?.Product_Order_Details?.map((product) => (
                    <>
                      <div className="text-highlight">
                        <span>
                          <b>Product Name</b>
                        </span>
                        :<span>{product?.Product?.name}</span>
                      </div>
                      <div className="order-info">
                        <span>
                          <b>Category Name</b>
                        </span>
                        :<span>{product?.Product?.p_category?.name} </span>
                      </div>
                    </>
                  ))}
                  <div></div>
                  <div className=" mt-3">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        setShowDetails({
                          show: item?.id,
                          data: item?.Product_Order_Details,
                        })
                      }
                    >
                      View All Details
                    </Button>
                  </div>
                </td>

                <td className="order-details">
                  <div className="order-id">
                    <span>
                      <b>Total SubTotal</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {parseFloat(item?.total_selling_price || 0).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Delivery Charges</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {parseFloat(item?.delivery_charges || 0).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Offer Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {parseFloat(item?.total_offer_discount || 0).toFixed(2)}{" "}
                      /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Coupon Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {parseFloat(item?.total_coupon_discount || 0).toFixed(2)}{" "}
                      /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Convenience Fee</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {parseFloat(item?.platform_fee || 0).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Cess Tax</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{parseFloat(item?.cess_tax || 0).toFixed(2)} /-</span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Total Tax</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {parseFloat(item?.total_tax || 0).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id">
                    <span>
                      <b>Grand Total</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span>
                      {parseFloat(item?.total_amount || 0).toFixed(2)} /-
                    </span>
                  </div>
                </td>

                <td>
                  <>
                    <div className="text-highlight">
                      <span>{item?.User_Address?.Address_Type?.name}</span>
                    </div>
                    <div className="text-highlight">
                      <span>{item?.User_Address?.contact_no} </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {item?.User_Address?.first_name}{" "}
                        {item?.User_Address?.last_name}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{item?.User_Address?.floor} floor ,</span>
                      <span>{item?.User_Address?.building}, </span>
                      <span>{item?.User_Address?.apartment} ,</span>
                      <span>{item?.User_Address?.street}, </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item?.User_Address?.Users_Address_Detail?.Area?.name},{" "}
                      </span>
                      <span>
                        {item?.User_Address?.Users_Address_Detail?.City?.name} ,
                      </span>
                      <span>
                        {item?.User_Address?.Users_Address_Detail?.State?.name},{" "}
                      </span>
                      <span>
                        {
                          item?.User_Address?.Users_Address_Detail?.Country
                            ?.name
                        }
                        ,
                      </span>

                      <span>
                        {
                          item?.User_Address?.Users_Address_Detail?.Pincode
                            ?.name
                        }
                      </span>
                    </div>

                    <div className="text-highlight">
                      <span>
                        <b>Delivery Notes : </b>{" "}
                      </span>
                      <span>{item?.delivery_note || "null"} </span>
                    </div>

                    <div className="text-highlight">
                      <span>
                        <b>Delivery Date : </b>{" "}
                      </span>
                      <span>
                        {formatDateToIST(item?.delivery_date) || "null"}{" "}
                      </span>
                    </div>

                    <div className="text-highlight">
                      <span>
                        <b>Delivery Time : </b>{" "}
                      </span>
                      <span>
                        {item?.Time_Slot?.from || "null"}-
                        {item?.Time_Slot?.to || "null"}{" "}
                      </span>
                    </div>
                  </>
                </td>

                <td>
                  {item?.order_status_id === 4 ? (
                    <div>
                      <p className="status-holder shipped">
                        {item?.Order_status?.name}
                      </p>
                    </div>
                  ) : (
                    <div>
                      <p className="status-holder Unshipped">
                        {item?.Order_status?.name}
                      </p>
                    </div>
                  )}
                </td>

                <td>
                  <div className="my-1">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        ChangeOrderStatus(item?.id, OrderStatusIds.Processing)
                      }
                    >
                      {" "}
                      Accept Order{" "}
                    </Button>
                  </div>

                  {/* <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() =>
                        ChangeOrderStatus(item?.id, OrderStatusIds.Cancelled)
                      }
                    >
                      {" "}
                      Reject Order{" "}
                    </Button>
                  </div> */}

                  {/* <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                    >
                      Print Tax Invoice
                    </Button>
                  </div> */}

                  {item?.order_status_id !== OrderStatusIds.Cancelled && (
                    <div className="my-1">
                      <Button
                        className="action-btn"
                        onClick={() =>
                          setShowCancelOrder({ show: item?.id, data: item })
                        }
                      >
                        Cancel Order
                      </Button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>

      <CancelOrderModel
        GetAllCounts={GetAllCounts}
        getDataAll={getDataAll}
        handleClose={() => {
          setShowCancelOrder({ show: 0, data: {} });
        }}
        setShow={() => setShowCancelOrder({ show: 0, data: {} })}
        show={showCancelOrder?.show}
        data={showCancelOrder?.data}
      />
      {/* <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />
      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      /> */}
      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />

      {show ? (
        <AddOffCanvance
          getDataAll={getDataAll}
          GetAllCounts={GetAllCounts}
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}
    </section>
  );
}

export default PendingOrdersTable;
